import { type ApiClient, QuarkFormations } from '@prismo-io/schemas';
import { z } from 'zod';

const QuarkFormationsArray = z.array(QuarkFormations);

export const fetchFormations = async (client: ApiClient, userId: string) => {
  // const {
  //   data: { session },
  // } = await client.auth.getSession();

  // if (!session) {
  //   throw new Error('You must be connected');
  // }

  const { data: formations } = await client
    .from('quark_formations')
    .select('*')
    .eq('user_id', userId)
    .order('favorite', { nullsFirst: false })
    .order('end_at', { ascending: false, nullsFirst: true })
    .order('start_at', { ascending: false, nullsFirst: false })
    .throwOnError();

  return QuarkFormationsArray.parse(formations);
};
